<ng-template #contentHeaderTemplate></ng-template>

@if (patient?.id) {
  <app-tab-switcher
    [config]="[
    {link: '/patients/' + this.patient!.id, translationKey: 'authenticated.patients.edit.tabs.details', exact: true},
    {link: '/patients/' + this.patient!.id + '/documents', translationKey: 'authenticated.patients.edit.tabs.documents', exact: true},
    {link: '/patients/' + this.patient!.id + '/emails', translationKey: 'authenticated.patients.edit.tabs.emails', exact: false},
    {link: '/patients/' + this.patient!.id + '/history', translationKey: 'authenticated.patients.edit.tabs.history', exact: false},
  ]"
  ></app-tab-switcher>

<div class="pb-2">
  <div class="card">
    <div class="card-body">
      <app-table
        id="dashboard.patients.emails.index"
        [replaceParametersInUrl]="{'{patient}': patient!.id}"
        [showEditLink]="false"
        [showTopRow]="false"
        [additionalButton]="showSentEmailButton"
        [additionalButtonWidth]="75"
        [showBorder]="false"
      ></app-table>
    </div>
  </div>
</div>
}

<ng-template #showSentEmailButton let-sentEmail>
  <button
    type="button"
    class="btn btn-outline-primary btn-sm"
    (click)="showEmail(sentEmail)"
  >
    <i class="fa fa-eye"></i>
  </button>
</ng-template>

<ng-template #emailPreviewModal>
  <div class="modal-body">
    <div class="ratio" style="--bs-aspect-ratio: 141%;">
      <iframe
        [srcdoc]="previewHtml"
      ></iframe>
    </div>
  </div>
</ng-template>
